import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { AuthProps } from '../../../dorian-shared/types/auth/AuthProps';
import {
  getToolRole, hasToolAccess, TOOL_PERMISSIONS_KEY,
} from '../../utils/toolAccessUtils';
import { DiscoverShelves } from '../DiscoverShelves/DiscoverShelves';
import { PromotionsRouter } from '../Promotions/PromotionsRouter';
import { ToolPermissions } from '../ToolPermissions/ToolPermissions';
import { ToolComponentProps } from './toolComponentProps';

export type { ToolComponentProps };

/**
 * The client's entire knowledge of what tools exist. A key the server grants
 * but that is missing here is skipped everywhere, so the API can ship a tool
 * ahead of the client without leaving a dead menu item.
 */
const TOOL_COMPONENTS: Record<string, React.ComponentType<any>> = {
  [TOOL_PERMISSIONS_KEY]: ToolPermissions,
  'discover-shelves': DiscoverShelves,
  promotions: PromotionsRouter,
};

export function getRegisteredToolKeys() {
  return Object.keys(TOOL_COMPONENTS);
}

export interface ToolPageProps {
  auth: AuthProps;
  match: {
    path: string;
    url: string;
    params: {
      toolKey: string;
    };
  };
}

export function ToolPage(props: ToolPageProps) {
  const { auth, match } = props;
  const { toolKey } = match.params;
  const user = auth.getUser();
  const Component = TOOL_COMPONENTS[toolKey] || null;
  const toolRole = getToolRole(user, toolKey);

  useEffect(() => {
    document.title = user?.tools?.find((tool) => tool.key === toolKey)?.title || 'Tool';
  }, [toolKey, user]);

  if (!hasToolAccess(user, toolKey)) {
    return <Redirect to="/" />;
  }

  if (!Component) {
    return <Redirect to="/" />;
  }

  return <Component {...props} toolKey={toolKey} toolRole={toolRole} />;
}
